export default {
  title: 'Disponibilidad de reservas',
};
